@import (reference) '../../../constants/spacing.module.less';

@max-width: 1327px;
@gutter-width: @space-32;

.overview-background {
  flex: 1;
  display: flex;
  flex-flow: column nowrap;

  background: var(--default--background-color--1);
  overflow: auto;
  scrollbar-gutter: stable both-edges;
}

.overview {
  flex: 1;
  display: flex;
  flex-flow: column nowrap;

  background: inherit;
  padding-left: @gutter-width;
  padding-right: @gutter-width;
  max-width: @max-width;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}
